import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button/Button';

const SeeMoreButton = ({ moreButtonText, isExpanded, onClick }) => (
    <Button
        dataTourStep="see-more-button"
        dataTourAllowInteraction
        className="see-more-button btn btn-secondary border-top"
        text={
            <>
                <span className="see-more-text font-weight-bold">
                    {isExpanded ? 'See less' : moreButtonText}
                </span>
                <i className={`icon-amplify-arrow-top ${isExpanded ? '' : 'rotate'}`} />
            </>
        }
        onClick={onClick}
    />
);

SeeMoreButton.defaultProps = {
    isExpanded: true,
    onClick: () => {},
    moreButtonText: 'See more',
};

SeeMoreButton.propTypes = {
    isExpanded: PropTypes.bool,
    onClick: PropTypes.func,
    moreButtonText: PropTypes.string,
};

export default SeeMoreButton;
